export const buttonCss = {
  padding: 0,
  transition: "none",
};

const sharedIconCss = {
  "&&&&": {
    height: "24px",
    width: "24px",
  },
  path: {
    strokeWidth: 3,
    transition: "none",
  },
};

export const labelCss = {
  marginLeft: 0,
};

export const desktopIconCss = {
  ...sharedIconCss,
  fontSize: "1rem",
};

export const mobileIconCss = {
  ...sharedIconCss,
};

export const buttonOverrideCss = {
  gap: "unset",
  padding: 0,
};
